<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="技术老师：">
        <el-select v-model="query.technicianInfoId" placeholder="请选择" clearable size="small" @change="changeIdentity" filterable :filter-method="parentFilter" @blur="handleTechnical()">
          <el-option v-for="(item,index) in identityOptions" :key="item.id" :label="`${item.realName}(${item.levelName})${item.mobile}`"
            :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="统计时间：">
        <el-date-picker v-model="dateTime" value-format="yyyy" type="year" placeholder="选择年" size="mini"
          :clearable="false" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import technicianQuotaApi from '@/api/technical/technicianQuota'
import technicianInfoApi from '@/api/technical/technicianInfo'
export default {
  props: ['isIntegral'],
  data() {
    return {
      dateTime: '',
      list: [],
      total: 0,
      listLoading: true,
      query: {
        type: undefined
      },
      identityOptions:[],
    }
  },
  created() {
    this.dateTime=this.dayjs().year()+''
    this.handleTechnical()
  },
  methods: {
    async handleTechnical(val){
      let obj={
        status: 10,
        pageNo:1,
        pageSize:100,
        realName:val
      }
      technicianInfoApi.listPageForMini(obj).then(({
        data
      }) => {
        this.identityOptions = data.list
        // console.log('this.identityOptions: ',this.identityOptions);
      })
    },
    handleDownload() {
      this.query.quotaDateStart = this.dateTime && this.dateTime.length > 0 ? `${this.dateTime}-01-01 00:00:00` : undefined
      this.query.quotaDateEnd = this.dateTime && this.dateTime.length > 0 ? `${this.dateTime}-12-31 23:59:59` : undefined
      let query={
        ...this.query,
        ids:this.query.technicianInfoId
      }
      delete query.technicianInfoId
      return this.$common.confirm('是否确认导出')
        .then(() => technicianInfoApi.exportQuota(query)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 500)

          }
        })
    },

  }

}
</script>

<style>
</style>
